export const PX_PER_LEVEL = 22;
export const COLLAPSE_THRESHOLD = 5;
export const LABEL_THRESHOLD = 20;
export const GAP = 0.5;
export const BAR_HEIGHT = PX_PER_LEVEL - GAP;
